import { createFileRoute, Outlet } from '@tanstack/react-router';
import { ProtectedRoute } from '../components/auth/index.js';

/**
 * @graph-node {Page}
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business アカウント管理レイアウト。MANAGE_ACCOUNTS権限チェックを行いアカウント関連ページをラップ
 * @graph-connects ProtectedRoute [calls] 権限チェックコンポーネント呼び出し
 */
export const Route = createFileRoute('/accounts')({
  component: AccountsLayout,
});

/** @graph-connects none */
function AccountsLayout() {
  return (
    <ProtectedRoute pageKey="accounts">
      <Outlet />
    </ProtectedRoute>
  );
}
